import drone from "../../../assets/drone.jpg";
import gestion from "../../../assets/gestionAMb.jpg";
import hys from "../../../assets/hys.jpg";
import ingenieria from "../../../assets/ingenieria.jpg";
import mantenimiento from "../../../assets/mantenimin.jpg";
import paneles from "../../../assets/paneles.jpg";
import planeamiento from "../../../assets/PLANEAMMM.jpg";
import seminarios from "../../../assets/seminarios.jpg";

// Services data
export const services = [
  {
    id: 1,
    title: "SERVICIOS DE GESTIÓN AMBIENTAL",
    image: gestion,
    services: [
      "Estudios de Impacto Ambiental.",
      "Adecuaciones productivas en relación con el Ambiente.",
      "Manejo de Residuos Peligrosos.",
      "Proyectos y Programas de Residuos Sólidos Municipales.",
      "Representación Técnica Ambiental exigidas por contratos de obra.",
      "Gestión Ambiental Responsabilidad Ambiental de Obras.",
    ],
  },
  {
    id: 2,
    title: "SERVICIOS DE INGENIERÍA",
    image: ingenieria,
    services: [
      "Inspección de Obras Civiles.",
      "Inspección de Obras Hidráulicas.",
      "Inspección de Obras Viales.",
      "Inspecciones Ambientales de Obras.",
      "Mediciones y Relevamientos de Obra.",
      "Mediciones Ambientales. (particulado, ruidos, suelo y agua).",
      "Manejo de Residuos Peligrosos.",
    ],
  },
  {
    id: 3,
    title: "MANTENIMIENTO Y SERVICIOS",
    image: mantenimiento,
    services: [
      "Mantenimiento en espacios verdes Públicos y Privados.",
      "Realizamos podas y destronques.",
      "Suministros y colocación de césped y plantas ornamentales.",
      "Fumigaciones en propiedades públicas y privadas.",
      "Servicio de pintura en lugares privados y públicos",
      "Servicio de albañilería y plomería.",
      "Servicio de instalación de electricidad.",
    ],
  },
  {
    id: 4,
    title: "SEMINARIOS",
    image: seminarios,
    services: [
      "Los siguientes seminarios se dictan en forma individual o colectiva y están dirigidos a ejecutivos y al personal de cualquier empresa u organismo. Las mismas incluyen:",
      "Buenas Prácticas Ambientales.",
      "Herramientas de Administración para Ejecutivos.",
      "Como ejecutar un programa.",
      "Contratación de Recursos Humanos.",
      "Imagen y Relaciones Públicas.",
      "Educación y Competencia laboral.",
      "Ética Empresarial.",
    ],
  },
  {
    id: 5,
    title: "PLANEAMIENTO",
    image: planeamiento,
    services: [
      "Dirección de una investigación metódica, realizada por profesionales que se requieran en el área y reportes de progreso permanentes sin tener que abandonar sus obligaciones ejecutivas.",
      "Un programa detallado para seguir paso a paso reduciendo en un altísimo porcentaje la especulación y la improvisación.",
      "Una certeza de poder tener resultados en un tiempo estipulado según la dificultad y cantidad de la tarea de investigación, planificación y ejecución demandada.",
      "Considerable reducción de tiempo de ejecución (en un 30% o 40%) y ahorro de dinero en el corto y largo plazo.",
      "Una garantía de éxito mucho mayor.",
    ],
  },
  {
    id: 6,
    title: "SERVICIOS DE HIGIENE Y SEGURIDAD EN EL TRABAJO",
    image: hys,
    services: [
      "Dirección de una investigación metódica, realizada por profesionales que se requieran en el área y reportes de progreso permanentes sin tener que abandonar sus obligaciones ejecutivas.",
      "Un programa detallado para seguir paso a paso reduciendo en un altísimo porcentaje la especulación y la improvisación.",
      "Una certeza de poder tener resultados en un tiempo estipulado según la dificultad y cantidad de la tarea de investigación, planificación y ejecución demandada.",
      "Considerable reducción de tiempo de ejecución (en un 30% o 40%) y ahorro de dinero en el corto y largo plazo.",
      "Una garantía de éxito mucho mayor.",
    ],
  },
  {
    id: 7,
    title: "SERVICIO DE RELEVAMIENTO AÉREO",
    image: drone,
    services: [
      "Relevamiento de obras en ejecución.",
      "Relevamiento de zonas rurales anegadas.",
    ],
  },
  {
    id: 8,
    title: "LUMINARIAS SOLARES",
    image: paneles,
    services: [
      "Desarrollamos los proyectos de alumbrado público de forma conjunta con nuestros clientes. Proporcionamos un servicio todo en uno, desde la fabricación de las estructuras hasta la ejecución completa de los proyectos, incluyendo la provisión y montaje.",
    ],
  },
];

// Section data
export const sectionData = {
  title: "Nuestros servicios",
  description:
    "IMAPRO tiene como objetivo ofrecer soluciones personalizadas que respondan a las distintas necesidades de cada cliente, garantizando un servicio eficiente y de alta calidad. Contamos con personal altamente capacitado y con amplia experiencia en el rubro, además de profesionales especializados comprometidos con la excelencia. Utilizamos productos, recursos y materiales de primera calidad, para que usted solo deba ocuparse de disfrutar y optimizar su tiempo. Asimismo, nuestros presupuestos son altamente competitivos, adaptados a las condiciones del mercado actual.",
};
